import React, { createRef, useEffect, useMemo, useState } from "react";
import MenuBar from "./menu/MenuBar";
import Footer from "./footer/Footer";
import LeftIndex from "./navbar/Layouts";
import { useScreenshot, createFileName } from "use-react-screenshot";
import { useLocation } from "react-router-dom";

const Index = () => {
  const location = useLocation();
  const [imageName, setImageName] = useState("");
  const ref = createRef(null);

  function getLastSegment(url) {
    url = url.replace(/\/$/, "");
    const segments = url.split("/");
    if (!isNaN(segments[segments.length - 1])) {
      segments.pop();
    }
    return segments[segments.length - 1];
  }

  useMemo(() => {
    setImageName(getLastSegment(location.pathname));
  }, [location.pathname]);

  const download = (image, { name = imageName, extension = "jpg" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  const [image, takeScreenShot] = useScreenshot({
    type: "image/jpeg",
    quality: 1.0,
  });

  const downloadScreenshot = () => {
    takeScreenShot(ref.current).then(download);
  };

  return (
    <div style={{ width: "100%" }} ref={ref}>
      <MenuBar downloadScreenshot={downloadScreenshot} />
      <LeftIndex />
      <Footer />
    </div>
  );
};

export default Index;
